export default {
    GTM_ID: 'GTM-W3WNN2R',
    ENV: process.env.NODE_ENV
}